/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/motherhood/components/standalone/Navigation/theme';

export const NavigationTheme = theme;
